import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ProductOwner } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/ProductOwner";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { MotorcycleProduct } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/MotorcycleProduct";
import React from "react";

export const motorcycleDetailsList = (
  product: MotorcycleProduct,
  types: any,
  lang: string,
): ProductDetail[] => {
  return [
    {
      name: "deductible",
      value: (
        <DeductibleValue
          value={product.priceSpecifications.deductible.code ?? "??"}
        />
      ),
    },
    {
      name: "insuranceHolderIsMotorcycleOwner",
      value: (
        <ProductOwner
          isOwner={product.insuranceHolderIsOwner}
          owner={product.owner}
        />
      ),
    },
    {
      name: "mortgagee",
      value: <YesOrNo value={product.mortgagee ?? false} />,
    },
    {
      name: "damageRecentYears",
      value: product.damageCountRecentYears ?? 0,
    },
    {
      name: "yearOfLastDamage",
      value: product.yearOfLastDamage,
      hidden: product.damageCountRecentYears === 0,
    },
    {
      name: "users",
      value: types.userGroup[product.usabilityCode][lang],
    },
    {
      name: "garage",
      value: <YesOrNo value={product.hasGarageForMotorcycle ?? false} />,
    },
    {
      name: "lock",
      value: <YesOrNo value={product.mcLocker ?? false} />,
    },
    {
      name: "bonus",
      value: types.bonusLevelCode[product.bonusLevelCode],
    },
  ];
};
